module.exports = __webpack_public_path__ + "static/media/feature_4_1.110bec9a.jpg";